// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"99b2f9910165c6f7","4902":"46aa56c5cbff7324"}[chunkId] + ".css";
};